import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Switch, Route } from 'react-router-dom';
import { push } from 'connected-react-router';

// containers
import Buy from './screens/Buy';
import Callback from './screens/Callback';
import Order from './screens/Order';

/**
 * Giftcard
 */
 class Giftcard extends React.PureComponent {
  state = {
    routes: [
      {
        pathname: '/giftcard',
        component: Buy,
      },
      {
        pathname: '/giftcard/order/:result/:basketId',
        component: Order,
      },
      {
        pathname: '/giftcard/callback/:basket/:method',
        component: Callback,
      },
    ],
    width: '100%'
  }


  render() {
    return (
      <>       
        <Switch>
          <div style={{ margin: 20}}>
          {
            this.state.routes.filter((r) => r.component !== '').map((route, i) => (
              <Route key={`route-${i}-${route.pathname}`} exact={true} path={route.pathname} component={route.component} />
            ))
          }
          </div>
        </Switch>
      </>
    )    
  }
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Giftcard));